import React, { Component } from 'react';
import './Content/Styles/Profile.css';
import JobDetails from './JobDetails';
import Collapsible from 'react-collapsible';
import classnames from 'classnames';

class Profile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            openTab: '1'
        };

    }

    

    openTab(tab)
    {
        console.log(tab);
        this.setState({ activeTab: tab });
    }

    render() {
        return (
            <div className="pageBackground profilePage">
                <div>
                    <div className="linedinLogoContainer">
                        <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/pawan-rijhwani">
                            <img className="linkedinLogo" src={require("./Content/Images/Linkedin-logo.png")} alt="FB" />
                        </a>
                    </div>
                    <div className="profileHeader">
                        <h1 className="profileHeaderTitle">Personal Profile</h1>
                    </div>
                </div>
                <div className="profileContent">
                    Pawan S Rijhwani
                    <br />
                    San Ramon, CA 94583
                    <br/>
                    Cell: 510-828-2653
                    <br/>
                </div>
                <div className="profileContent">
                    <br/>
                    <Collapsible className="profileTitle" trigger="Summary">
                        <hr className="lineSeperator" />
                        <div>
                            Pawan Rijhwani is a Solutions Engineer specializing in Microsoft Technologies. Pawan has 9+ years of development experience with ASP.NET using C#, HTML, CSS, JavaScript, jQuery and SQL Server. In addition, he also has 3+ years of experience with WCF, and RESTful APIs. He is currently working with ReactJS. Pawan has 3+ years of experience with leading teams to successful deliveries. Pawan is interested in programming opportunities to employ his programming and analytical skills integrated with versatility, leadership and teamwork qualities for the growth of organization and self-career enhancement.
                        </div>
                    </Collapsible>
                    <Collapsible className="profileTitle" trigger="Skills">
                        <hr className="lineSeperator" />
                        <div>
                            C#, RESTful Web Services, WCF/SOAP web Services, XML, ASP .NET w/ MVC, JavaScript, jQuery, ReactJS, Bootstrap, T-SQL, SSIS, CSS, CSS3, HTML, HTML5, Entity Framework, Windows Presentation Foundation (WPF), SCRUM/Agile, Waterfall, SCRUM Master, Team Foundation Server(TFS), Rational Team Concert (RTC), Tortoise CVS and SVN, Urban Code Deploy, Source Code Management, Source Code Review, Source Code Coverage, TDD, NUnit Testing, Distributed systems.
                        </div>
                    </Collapsible>
                    <Collapsible className="profileTitle" trigger="Experience">
                        <hr className="lineSeperator" />
                        <div>
                            <JobDetails company="Avanade"
                                position="Multiple Positions"
                                startmonth="August" startyear="2012"
                                isPresent={true}
                                jobDetails1="Worked on various applications in various technologies front end and backend."
                                jobDetails2="Have played a lead on several projects with maximum team being two teams of 11."
                                jobDetails3="Worked to help improve the regional Software Engineering team."
                                jobDetails4="Front end technologies used: C# .NET, HTML, CSS, JavaScript, and ReactJS."
                                jobDetails5="Backend technologies used: SOAP, RESTful API, and SQL Server."
                                jobDetails6="Design Patterns used: MVC, and Singleton."
                                jobDetails7="Delivery Models used: SCRUM/Agile, Waterfall." />
                            <JobDetails company="Lundquist Consulting"
                                position="Software Developer"
                                startmonth="April" startyear="2011"
                                isPresent={false}
                                endmonth="July" endyear="2012"
                                jobDetails1="Repull Docket Limiter – Screen scraping HTML pages to collect data and store in database. Technologies used - ASP .NET 4.0, and C#."
                                jobDetails2="Rule 3001/3002 changes – Changes made to SharePoint web parts and a website to modify an existing form and add a new form to be filled by customers. Technologies used - ASP .NET 1.1, ASP .NET 2.0, JavaScript, CSS, VB, and C#." />
                            <JobDetails company="Briggs & Stratton Corporation"
                                position="Web Development Intern"
                                startmonth="May" startyear="2010"
                                isPresent={false}
                                endmonth="October" endyear="2010"
                                jobDetails1="iPace – Created a UI/UX search and compare pages for a project. Technologies used – ASP .NET 3.5, jQuery, JavaScript, AJAX, and C#."
                                jobDetails2="Conversion – Converted application from .NET 1.1 to .NET 3.5. Technologies used - ASP .NET 1.1, ASP .NET 2.0, ASP .NET 3.5, and C#."/>
                            <JobDetails company="University of Wisconsin, Oshkosh – MIO"
                                position="Web Developer	"
                                startmonth="February" startyear="2009"
                                isPresent={false}
                                endmonth="March" endyear="2010"
                                jobDetails1="YouTube module – Created a UI/UX module to get the RSS feed from www.youtube.com and show it on campus portal site with the options to view top viewed, most popular, etc."
                                jobDetails2="Network Access Request Form – Modified an existing UI/UX module and application to update the needs of network administrator"
                                jobDetails3="Random Links Application and Module – The random links application and module were built for users to be able to post links to the module to share. The UI/UX application was more of an admin use which was used to verify reported links."
                                jobDetails3="Technologies used in all applications - ASP .NET 3.5, JavaScript, CSS, C#, SQL Server, and ASMX web services."/>
                        </div>
                    </Collapsible>
                    <Collapsible className="profileTitle" trigger="Education and Certifications">
                        <hr className="lineSeperator" />
                                            <div>
                        <ul>
                            <li>
                                <JobDetails position="University of Wisconsin - Oshkosh"
                                    startmonth="September" startyear="2007"
                                    isPresent={false}
                                    endmonth="December" endyear="2010"
                                    details="Bachelor of Science - Computer Science" />
                            </li>
                            <li>
                                <JobDetails position="MCSD 70-532 – Developing Microsoft Azure Solutions"
                                    startmonth="July" startyear="2017"
                                    isPresent={true} />
                            </li>
                        
                        </ul>
                    </div>
                    </Collapsible>
                </div>
            </div>
        );
    }
}
export default Profile;
